module.exports = __webpack_public_path__ + "111e260a971d3fe48b87244e42bd9c48.jpg";